import { Assets, type AssetsManifest } from "pixi.js";

/**
 * Registers the game's built-in asset bundles. Paths are relative so they resolve on the web and in
 * the native shell. Remote content comes from a CDN on another origin, so images load with CORS.
 */
export async function initAssets(manifest: AssetsManifest): Promise<void> {
  await Assets.init({ manifest, preferences: { crossOrigin: "anonymous" } });
}

/** Loads one or more bundles, reporting progress from 0 to 1. */
export async function loadBundles(names: string | string[], onProgress?: (progress: number) => void): Promise<void> {
  await Assets.loadBundle(names, onProgress);
}

/** Starts fetching bundles that are not needed yet, without blocking the current scene. */
export function preloadBundles(names: string | string[]): void {
  void Assets.backgroundLoadBundle(names);
}
